var React = require('react');

function Invite (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_1-2"},React.createElement("path",{"d":"m48.75,16.25h-5v-5c0-.69-.56-1.25-1.25-1.25h-2.5c-.69,0-1.25.56-1.25,1.25v5h-5c-.69,0-1.25.56-1.25,1.25v2.5c0,.69.56,1.25,1.25,1.25h5v5c0,.69.56,1.25,1.25,1.25h2.5c.69,0,1.25-.56,1.25-1.25v-5h5c.69,0,1.25-.56,1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25Zm-31.25,3.75c5.52,0,10-4.48,10-10S23.02,0,17.5,0,7.5,4.48,7.5,10s4.48,10,10,10Zm7,2.5h-1.3c-1.73.8-3.66,1.25-5.7,1.25s-3.95-.45-5.7-1.25h-1.3c-5.8,0-10.5,4.7-10.5,10.5v3.25c0,2.07,1.68,3.75,3.75,3.75h27.5c2.07,0,3.75-1.68,3.75-3.75v-3.25c0-5.8-4.7-10.5-10.5-10.5Z"})));
}

Invite.defaultProps = {"id":"Layer_2","viewBox":"0 0 50 40"};

module.exports = Invite;

Invite.default = Invite;
